// TODO: write documentation about fonts and typography along with guides on how to add custom fonts in own
// markdown file and add links from here

import { Platform } from "react-native"

import { Capriola_400Regular as capriolaRegular } from "@expo-google-fonts/capriola"
import { Poppins_500Medium as poppin } from "@expo-google-fonts/poppins"
import { Poppins_300Light as poppinThin } from "@expo-google-fonts/poppins"
export const customFontsToLoad = {
  capriolaRegular,
  poppin,
  poppinThin,
}

const fonts = {
  capriola: {
    normal: "capriolaRegular",
  },
  helveticaNeue: {
    // iOS only font.
    thin: "HelveticaNeue-Thin",
    light: "HelveticaNeue-Light",
    normal: "HelveticaNeue",
    medium: "HelveticaNeue-Medium",
  },
  courier: {
    // iOS only font.
    normal: "Courier",
  },
  sansSerif: {
    // Android only font.
    thin: "sans-serif-thin",
    light: "sans-serif-light",
    normal: "sans-serif",
    medium: "sans-serif-medium",
  },
  monospace: {
    // Android only font.
    normal: "monospace",
  },
  lexend: {
    // Android only font.
    normal: "lexend",
  },
  poppin: {
    normal: "poppin",
  },
  poppinThin: {
    normal: "poppin",
  },
}

export const typography = {
  // primary: fonts.capriola,
  primary: fonts.poppin,
  thin: fonts.poppinThin,
  helveticaNeue: fonts.helveticaNeue,
}
